import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import * as storage from 'src/lib/storage';
import type { BackendMutationAcceptExternalSignupArgs, BackendToken } from 'src/types/backend';

const MUTATION = gql`
  mutation AcceptExternalSignup(
    $token: String!
    $password: String!
    $signupDevice: String!
    $impactClickId: String
  ) {
    acceptExternalSignup(
      token: $token
      password: $password
      signupDevice: $signupDevice
      impactClickId: $impactClickId
    ) {
      token
    }
  }
`;

type Variables = Omit<BackendMutationAcceptExternalSignupArgs, 'impactClickId'>;
type Result = BackendToken;

export const acceptExternalSignup = async ({ token, password, signupDevice }: Variables) => {
  const impactClickId = storage.readItem('impactClickId');
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { token, password, signupDevice, impactClickId },
  });
  return getSingleProp<Result>(result.data);
};
